/* ============================================================
   TSS Acne Hero — smooth-scroll the rating row to the Custom
   Reviews section (.cr-section). Enabled per-section via the
   "Scroll to reviews on rating click" toggle, which renders the
   [data-pak-hero-rating-scroll] hook. Document-level delegation
   keeps it working across theme-editor section re-renders.
   ============================================================ */

(() => {
  const scrollToReviews = () => {
    const target = document.querySelector('.cr-section');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pak-hero-rating-scroll]');
    if (!trigger) return;
    event.preventDefault();
    scrollToReviews();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest?.('[data-pak-hero-rating-scroll]');
    if (!trigger || trigger !== event.target) return;
    event.preventDefault();
    scrollToReviews();
  });
})();
